import type { ButtonHTMLAttributes } from 'react';

import type { Haptic } from '../../lib/telegram';
import { pressable, withHaptic } from './pressable';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

const variants: Record<Variant, string> = {
	primary: 'bg-primary text-text',
	secondary: 'bg-surface text-text border border-border',
	ghost: 'bg-transparent text-primary',
	danger: 'bg-danger text-text',
};

/**
 * Pill button, ≥ 44 px touch target (DESIGN). Every press scales and gives a light haptic
 * (DESIGN → Motion); pass `haptic` for an outcome (`success`, `warning`) or `false` for none.
 */
export function Button({
	variant = 'primary',
	className = '',
	type = 'button',
	haptic = 'light',
	onClick,
	...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; haptic?: Haptic | false }) {
	return (
		<button
			type={type}
			className={`min-h-11 rounded-full px-6 text-body font-semibold active:opacity-80 disabled:opacity-50 disabled:active:scale-100 ${pressable} ${variants[variant]} ${className}`}
			onClick={withHaptic(onClick, haptic)}
			{...props}
		/>
	);
}
